import { AbilityBuilder } from '@casl/ability';
import { useMemo } from 'react';

import { defineAbilitiesForProjects, IProjectCalculatedSubject } from '../../../../common/abilities/projects';
import { CommonRenderRule, formatCondition, mapCommonPart, TypedConditionsRule } from './common';

type ProjectRule = TypedConditionsRule<IProjectCalculatedSubject>;

type ProjectRenderRule = CommonRenderRule & {
    subject: string;
};

export const useProjectRules = (): ProjectRenderRule[] =>
    useMemo(() => {
        const { rules, can, cannot } = AbilityBuilder.extract();

        defineAbilitiesForProjects(can, cannot);

        return (rules as ProjectRule[]).map(r => ({
            ...mapCommonPart(r),
            subject: formatCondition(r.conditions?.subSubject),
        }));
    }, []);
